import { GET_RECEIVER_DETAILS, GET_RECEIVER_DETAILS_BY_ID ,GET_REGULATORY_TYPES} from '../types'

const INITIAL_STATE = {
  allReceiverDetails: [],
  getOneReceiver: [],
  getAllRegulatoryType: [],
}

const receiverDetailsReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case GET_RECEIVER_DETAILS:
      return {
        ...state,
        allReceiverDetails: payload.data,
        loader: false,
      }
    // case ADD_INSITITUTION:
    //   return {
    //     ...state,
    //     addInsti: payload,
    //   }

    // case UPDATE_INSTITUTION:
    //   return {
    //     ...state,
    //     updateInsti: payload.data,
    //     loader: false,
    //   }

    case GET_RECEIVER_DETAILS_BY_ID:
      return {
        ...state,
        getOneReceiver: payload.data,
      }


      case GET_REGULATORY_TYPES:
      return {
        ...state,
        getAllRegulatoryType: payload.data,
      }

    default:
      return state
  }
}

export default receiverDetailsReducer
